export type Month = 'January' | 'February' | 'March' | 'April' | 'May' | 'June' | 'July' | 'August' | 'September' | 'October' | 'November' | 'December';

export const Month = {
    January: 'January' as Month,
    February: 'February' as Month,
    March: 'March' as Month,
    April: 'April' as Month,
    May: 'May' as Month,
    June: 'June' as Month,
    July: 'July' as Month,
    August: 'August' as Month,
    September: 'September' as Month,
    October: 'October' as Month,
    November: 'November' as Month,
    December: 'December' as Month
};